var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_2575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3298 11.6667C11.2502 11.6667 11.9964 10.9205 11.9964 10C11.9964 9.07954 11.2502 8.33334 10.3298 8.33334C9.40928 8.33334 8.66309 9.07954 8.66309 10C8.66309 10.9205 9.40928 11.6667 10.3298 11.6667Z",
    stroke: "#009621",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8629 6.46667C14.3278 6.93104 14.6966 7.48248 14.9482 8.08947C15.1999 8.69646 15.3294 9.34709 15.3294 10.0042C15.3294 10.6612 15.1999 11.3119 14.9482 11.9189C14.6966 12.5259 14.3278 13.0773 13.8629 13.5417M6.79627 13.5333C6.33139 13.069 5.96259 12.5175 5.71097 11.9105C5.45935 11.3035 5.32983 10.6529 5.32983 9.99584C5.32983 9.33876 5.45935 8.68813 5.71097 8.08114C5.96259 7.47415 6.33139 6.9227 6.79627 6.45834M16.2213 4.10834C17.7835 5.67107 18.6612 7.7903 18.6612 10C18.6612 12.2097 17.7835 14.3289 16.2213 15.8917M4.43793 15.8917C2.87567 14.3289 1.99805 12.2097 1.99805 10C1.99805 7.7903 2.87567 5.67107 4.43793 4.10834",
    stroke: "#009621",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_2575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.330078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.4934574d8c1db4c34403d0f630c57c31.svg";
export { ForwardRef as ReactComponent };